import React, { Component }   from 'react';
import ProfilePlaceholder     from 'assets/icons/profile-placeholder.png';
import { ConfirmAttendance }  from 'components/ConfirmAttendance/ConfirmAttendance';
import { formatCurrency }     from 'helpers/common.helper';
import moment               from 'moment';

export class PreregistrationCards extends Component {
  render() {
    const colorHash     = { 'Attended': 'success', 'Cancelled': 'primary', 'Upcoming': 'warning', 'Skipped': 'grey' };
    const statusHash    = { 'attended': 'Attended', 'cancelled': 'Cancelled', 'upcoming': 'Upcoming', 'skipped': 'Skipped' };
    const today         = moment().format('DD MMM YYYY');

    const patientCards  = this.props.items.map((hash, index) => {
      const displayedStatus = statusHash[hash.status];
      const color           = colorHash[displayedStatus];
      const displayedDate   = hash.date === today ? 'Today' : hash.date;

      return (
        <tr key={ hash.id } className="patient-card-row bg-white" value={ hash.status }>
          {/* Desktop View */}
            <td valign="top" className={ 'd-none d-lg-table-cell py-6 px-4 border-' + color }>
              <p className="fweight-500 font-size-6 mb-2">{ displayedDate }</p>
              <span className="font-size-4 mb-0">Ref No.: { hash.id }</span>
            </td>

            <td valign="top" className="d-none d-lg-table-cell py-6 pr-4">
              <div className="d-flex align-items-center">
                <img src={ ProfilePlaceholder } alt="profile" className="profile-placeholder mr-4"/>

                <span>
                  <p className="mb-1 font-size-6 fweight-500">{ hash.personal_info.policy_owner }</p>
                  <p className="mb-0 font-size-5 fweight-400 text-grey">{ hash.personal_info.company_name }</p>
                  <a href="derp" className="text-danger d-none">View Profile</a>
                </span>
              </div>
            </td>

            <td valign="top" className="d-none d-lg-table-cell py-6 pr-4">{ hash.practice_location.name }</td>
            <td valign="top" className="d-none d-lg-table-cell py-6 pr-4">{ 'MYR ' + formatCurrency(hash.claim_limit) }</td>
            <td valign="top" className={ 'd-none d-lg-table-cell py-6 pr-4 text-' + color }><b>{ displayedStatus }</b></td>
            <td valign="top" className="d-none d-lg-table-cell py-6 pr-4 border-"><ConfirmAttendance data={ hash } /></td>

          {/* Mobile View */}
            <td colSpan="6" valign="top" className={ 'd-table-cell d-lg-none font-size-7 py-6 pl-6 border-' + color }>
              <div className="d-flex justify-content-between mt-2 mb-2">
                <p className="mb-0 flex-grow-1">
                  <b className="d-inline-block w-em-15 font-size-6">{ displayedDate }</b>
                </p>

                <b className={ 'text-right text-' + color}>{ displayedStatus }</b>
                <ConfirmAttendance data={ hash } />
              </div>

              <div className="d-flex align-items-center mb-4">
                <img src={ ProfilePlaceholder } alt="profile" className="profile-placeholder mr-4"/>

                <span>
                  <p className="mb-1 font-size-6 fweight-500">{ hash.personal_info.policy_owner }</p>
                </span>
              </div>

              <div className="d-flex align-items-end justify-content-between mb-0 mr-8">
                <div>
                  <span className="d-inline-block w-em-13">Location:</span>
                  <b>{ hash.practice_location.name }</b><br/>
                  <span className="d-inline-block w-em-13">Claim Limit:</span>
                  <b>{ 'MYR ' + formatCurrency(hash.claim_limit) }</b>
                </div>

                <span className="font-size-3 mb-0">Ref No.: { hash.id }</span>
              </div>
            </td>
        </tr>
      )
    });

    const emptyHolder   = <tr className="patient-card-row bg-white">
      <td colSpan="6" className="text-center font-size-7 fweight-500 py-4" style={{ borderRadius: "0.5em" }}>No upcoming appointments</td>
    </tr>;

    const displayCards  = patientCards.length > 0 ? patientCards : emptyHolder;

    return (
      <table id="dashboard-cards-table" className="w-100">
        <thead className="d-none d-lg-table-header-group">
          <tr>
            {
              ['Date', 'Patient Profile', 'Practice Location', 'Visit Limit', 'Status', 'Actions'].map((name, index) => {
                const padding = index > 0 ? 'pr-4' : 'px-4';
                return <th key={ 'table-header-' + name } className={ "font-size-7 fweight-500 " + padding }>{ name }</th>
              })
            }
          </tr>
        </thead>

        <tbody>
          { displayCards }
        </tbody>
      </table>
    )
  }
}